<template>
  <el-dialog
    :title="`合伙人业绩设置（${agentName}）`"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="700px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-button
      type="primary"
      :loading="loading"
      @click="add">添加分段</el-button>
    <vue-slider
      v-model="list"
      style="margin:0 auto"
      tooltip="always"
      :tooltip-placement="tooltipPlacement"
      :max="1000"
      direction="ttb"
      :height="500"
      :process="process"
      :dot-options="dotOptions"
      :min-range="1">
      <template v-slot:tooltip="{ index }">
        <div
          class="vue-slider-dot-tooltip-inner"
          :class="[index % 2 === 0 ? 'vue-slider-dot-tooltip-inner-left' : 'vue-slider-dot-tooltip-inner-right']">
          <span>{{ listValue[index] | currency }}元</span>
          <span v-if="index > 0 && index < list.length -1">
            <i
              class="el-icon-edit ml-10"
              @click="editNum(listValue[index],index)"></i>
            <i
              class="el-icon-delete ml-10"
              @click="delNum(listValue[index],index)"></i>
          </span>
        </div>
      </template>
      <template v-slot:process="{ style, index }">
        <div
          class="vue-slider-process"
          :style="style">
          <div :class="[index % 2 === 0 ? 'merge-tooltip-r' : 'merge-tooltip', 'vue-slider-dot-tooltip-inner', index % 2 === 0 ? 'vue-slider-dot-tooltip-inner-left' : 'vue-slider-dot-tooltip-inner-right']">
            <div>分段金额：{{ ruleStages[index].thresholdBegin | currency }}-{{ ruleStages[index].thresholdEnd | currency }}元</div>
            <div>提成比例：{{ ruleStages[index].percent }}% <i
              class="el-icon-edit ml-10"
              @click="editPercent(index)"></i></div>
          </div>
        </div>
      </template>
    </vue-slider>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">保 存</el-button>
    </span>
    <partner-num-modal
      ref="modal"
      :callback="callback" />
    <partner-rate-modal
      ref="rate"
      :callback="callbackRate" />
  </el-dialog>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import PartnerNumModal from './partner-num-modal.vue'
import PartnerRateModal from './partner-rate-modal.vue'
import { mapState } from 'vuex'
import _ from 'lodash'
// const MAX_NUMBER = 2147483647
const MAX_LENGTH = 6
export default {
  name: 'PartnerModal',
  components: { VueSlider, PartnerNumModal, PartnerRateModal },
  props: {},
  data() {
    return {
      loading: false,
      visible: false,
      // list: [0, 2147483],
      agentName: null,
      agentId: null,
      ruleStages: [
        {
          thresholdBegin: 0,
          thresholdEnd: 200000000,
          percent: 0
        }
      ],
      process: val => {
        console.log('process')
        const len = val.length
        const ret = []
        for (let i = 0; i < len - 1; i++) {
          ret.push([val[i], val[i + 1]])
        }
        return ret
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    dotOptions() {
      const list = this.list
      return list.map(() => ({ disabled: true }))
    },
    tooltipPlacement() {
      return this.list.map((item, index) => index % 2 === 0 ? 'left' : 'right')
    },
    listValue() {
      const ruleStages = this.ruleStages
      const ret = []
      ruleStages.forEach((item, index) => {
        if (index === 0) {
          ret.push(item.thresholdBegin, item.thresholdEnd)
        } else {
          ret.push(item.thresholdEnd)
        }
      })
      return ret
    },
    list() {
      const ruleStages = this.ruleStages
      const ret = []
      ruleStages.forEach((item, index) => {
        // if (index === 0) {
        //   ret.push(item.thresholdBegin, item.thresholdEnd)
        //   // ret.push(0, (index + 1) * 20)
        // } else {
        //   ret.push(item.thresholdEnd)
        //   // ret.push((index + 1) * 20)
        // }
        ret.push(index * 150)
      })
      ret.push(1000)
      return ret
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {

    },
    add() {
      if (this.ruleStages.length >= MAX_LENGTH) {
        this.$message.error(`目前最多支持分${MAX_LENGTH}段`)
        return
      }
      // let list = this.list
      // let len = list.length
      // let min = list[len - 2] + 1000
      // let max = list[len - 1]
      // this.$refs.modal.init({ min, max, index: -1, value: min }, 'add')
      const ruleStages = _.cloneDeep(this.ruleStages)
      const len = ruleStages.length
      const last = ruleStages[len - 1]
      const min = last.thresholdBegin + 1000
      const max = last.thresholdEnd
      this.$refs.modal.init({ min, max, value: min }, 'add')
    },
    callback(v, type, index) {
      const ruleStages = _.cloneDeep(this.ruleStages)
      if (type === 'add') {
        const len = ruleStages.length
        const last = ruleStages[len - 1]
        const thresholdEnd = last.thresholdEnd
        last.thresholdEnd = v
        ruleStages.push({
          thresholdBegin: v,
          thresholdEnd: thresholdEnd,
          percent: 1
        })
      } else {
        ruleStages[index].thresholdBegin = v
        ruleStages[index - 1].thresholdEnd = v
      }
      this.ruleStages = ruleStages
      // this.list.splice(index, type === 'add' ? 0 : 1, v)
    },
    delNum(value, index) {
      this.$confirm('是否删除该分段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ruleStages = _.cloneDeep(this.ruleStages)
        const cur = _.cloneDeep(ruleStages[index])
        const pre = _.cloneDeep(ruleStages[index - 1])
        ruleStages.splice(index - 1, 2, {
          thresholdBegin: pre.thresholdBegin,
          thresholdEnd: cur.thresholdEnd,
          percent: 1
        })
        this.ruleStages = ruleStages
        // this.ruleStages.splice(index, 1)
      })
    },
    editNum(value, index) {
      const listValue = this.listValue
      const min = listValue[index - 1] + 1000
      const max = listValue[index + 1] - 1000
      this.$refs.modal.init({ min, max, index, value }, 'update')
      // let list = this.list
      // let min = list[index - 1] + 1000
      // let max = list[index + 1] - 1000
      // this.$refs.modal.init({ min, max, index, value }, 'update')
    },
    editPercent(index) {
      this.$refs.rate.init({ index, value: this.ruleStages[index].percent })
    },
    callbackRate(value, index) {
      this.$set(this.ruleStages, index, {
        ...this.ruleStages[index],
        percent: value
      })
    },
    getagentcommissionrule(cb) {
      this.loading = true
      this.$store.dispatch('agent/getagentcommissionrule', {
        payload: {
          agentId: this.agentId,
          vendorId: this.userInfo.orgId
        },
        success: (res) => {
          this.loading = false
          this.ruleStages = res.data.ruleStages
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      this.loading = true
      this.$store.dispatch('agent/configagentcommissionrule', {
        payload: {
          agentId: this.agentId,
          vendorId: this.userInfo.orgId,
          rule: JSON.stringify(this.ruleStages)
        },
        success: () => {
          this.loading = false
          // this.toggleModal(false)
          this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      if (row) {
        this.agentId = row.agentId
        this.agentName = row.agentName
      }
      this.getagentcommissionrule(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.merge-tooltip {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(15px, -50%);
  text-align: left;
}

.vue-slider-dot-tooltip-inner {
  padding: 3px 8px;
}

.merge-tooltip-r {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(-15px, -50%);
  text-align: left;
}

.ml-10 {
  margin-left: 10px;
  cursor: pointer;
}
</style>
